<script>
import Despacho from './components/Despacho/Despacho.vue'
import axios from '@/utils/api'

export default {
  components: {
    Despacho
  },
  props: {
    processo: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      active: [],
      despachos: []
    }
  },
  mounted () {
    this.despachos = this.processo
  },
  methods: {
    async handleChange (val) {
      if (!val || !val.length) return
      const lastInteract = val[val.length - 1]
      if (!this.despachos.find(despacho => despacho.id === lastInteract)?.loading) return
      const despachoView = await axios({
        method: 'GET',
        url: `despacho/view/byId/${lastInteract}`,
        loader: false
      })
      this.despachos = this.despachos.map(despacho => {
        if (despacho.id === lastInteract) {
          despacho = { ...despacho, ...despachoView, loading: false }
        }
        return despacho
      })
    }
  }
}
</script>

<template>
  <div>
    <div v-if="!despachos.length" style="display: flex; justify-content: center;">
      <span>Não há despachos registrados.</span>
    </div>
    <div v-else>
      <span class="title-processo">Dados do processo</span>
      <el-collapse v-model="active" @change="handleChange" class="container-collapse">
        <el-collapse-item v-for="despacho in despachos" :key="despacho.id" :name="despacho.id" :title="despacho.descricao" >
          <div v-loading="despacho.loading">
            <Despacho :despacho="despacho" />
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Processo/Processo.vue